module.exports = __webpack_public_path__ + "static/img/xnyzk.56ac92c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/xnyzk.png
// module id = 90aL
// module chunks = 44